import { useEffect, useRef } from 'react';
import { updateSEO, SEOConfig } from '@/lib/seo';

/**
 * Hook to manage SEO meta tags for a page
 * Automatically applies noindex for app domain pages
 * 
 * @param config - SEO configuration for the page
 */
export function useSEO(config: SEOConfig = {}) {
  const hasRun = useRef(false);
  
  useEffect(() => {
    // Only run once per mount to prevent flickering
    if (hasRun.current) return;
    hasRun.current = true;
    
    const cleanup = updateSEO(config);
    return () => {
      hasRun.current = false;
      cleanup();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
